import React from 'react';
import styles from './Programacion.module.scss';

/* TYPES */

type ChannelCode = 'MORBIDO' | '4FANGS';

type Movie = {
  title: string;
  time: string;
};

type ScheduleData = {
  channel: string;
  days: {
    [key: string]: Movie[];
  };
};

/* HELPERS */

function convertTime(time: string): string {
  const [h, m] = time.split(':').map(Number);

  const baseDate = new Date();
  baseDate.setUTCHours(h + 6, m, 0);

  return baseDate.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

function isLive(
  currentTime: Date,
  current: string,
  next?: string
): boolean {
  const [ch, cm] = current.split(':').map(Number);

  const start = new Date(currentTime);
  start.setHours(ch, cm, 0);

  let end = new Date(currentTime);

  if (next) {
    const [nh, nm] = next.split(':').map(Number);
    end.setHours(nh, nm, 0);
  } else {
    end.setHours(23, 59, 59);
  }

  return currentTime >= start && currentTime < end;
}

function getWeekDates(): Date[] {
  const today = new Date();
  const day = today.getDay();
  const diffToMonday = day === 0 ? -6 : 1 - day;

  const monday = new Date(today);
  monday.setDate(today.getDate() + diffToMonday);

  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    return d;
  });
}

/* COMPONENT */

const Programacion: React.FC = () => {
  const [channel, setChannel] = React.useState<ChannelCode>('MORBIDO');
  const [data, setData] = React.useState<ScheduleData | null>(null);
  const [error, setError] = React.useState<string | null>(null);
  const [currentTime, setCurrentTime] = React.useState(new Date());

  const weekDates = React.useMemo(() => getWeekDates(), []);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  React.useEffect(() => {
    const loadJson = async () => {
      const fileName =
        channel === 'MORBIDO'
          ? '/programacion_json/morbido.json'
          : '/programacion_json/4fangs.json';

      try {
        setError(null);
        const res = await fetch(fileName, { cache: 'no-store' });
        if (!res.ok) throw new Error();

        const json = await res.json();
        setData(json[0]);
      } catch {
        setError('Programación no disponible por el momento.');
      }
    };

    loadJson();
  }, [channel]);

  if (error) return <p>{error}</p>;
  if (!data) return <p>Cargando programación…</p>;

    //Solo toma el dia actual
  const today = new Date();
  const todayIndex = today.getDay();
  //lunes = 0
  const adjustedTodayIndex = todayIndex === 0 ? 6 : todayIndex - 1; 

  const ordenDias = [
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
  'Domingo',
];

const dias = ordenDias.filter(dia => data.days[dia]);

  const maxFilas = Math.max(
    ...dias.map((dia) => data.days[dia].length)
  );

  return (
    <div className={styles.container}>

      {/* Botón de regreso */}
      <button className={styles.backButton} onClick={() => window.location.href = 'https://umbra.stream'}>
        ✕
      </button>

      <h1 className={styles.title}>Programación Semanal</h1>

      <p className={styles.subtitle}>
        Los horarios se muestran en tu hora local
      </p>

      <div className={styles.channelTabs}>
        <button
          className={
            channel === 'MORBIDO'
              ? styles.channelTabActive
              : styles.channelTab
          }
          onClick={() => setChannel('MORBIDO')}
        >
          Mórbido TV
        </button>

        <button
          className={
            channel === '4FANGS'
              ? styles.channelTabActive
              : styles.channelTab
          }
          onClick={() => setChannel('4FANGS')}
        >
          4Fangs
        </button>
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.scheduleTable}>
          <thead>
            <tr>
              {dias.map((dia, index) => {
                const date = weekDates[index];

                return (
                  <th key={dia} className={styles.dayHeader}>
                    <div className={styles.dayHeaderContent}>
                      <span className={styles.dayName}>
                        {dia.toUpperCase()}
                      </span>
                      <span className={styles.dayDate}>
                        {date.toLocaleDateString('es-MX', {
                          day: 'numeric',
                          month: 'long',
                        })}
                      </span>
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>

          <tbody>
            {Array.from({ length: maxFilas }).map((_, rowIndex) => (
              <tr key={rowIndex}>
                {dias.map((dia, dayIndex) => {
                  const movies = data.days[dia];
                  const movie = movies[rowIndex];
                  const nextMovie = movies[rowIndex + 1];

                  const isTodayColumn = dayIndex === adjustedTodayIndex;

                  const live =
                    movie && isTodayColumn
                      ? isLive(currentTime, movie.time, nextMovie?.time)
                      : false;

                  /*const live = movie
                    ? isLive(currentTime, movie.time, nextMovie?.time)
                    : false;*/

                  return (
                    <td key={dia + rowIndex} className={styles.cell}>
                      {movie && (
                        <div
                          className={`${styles.movieBlock} ${
                            live ? styles.currentSlot : ''
                          }`}
                        >
                          <div className={styles.movieTitle}>
                            {movie.title}
                          </div>

                          <div className={styles.time}>
                            {convertTime(movie.time)}
                          </div>
                        </div>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Programacion; /////////////Este es el que subi/////////////